import { fetchGraphql } from "./graphqlClient";
import { signupMutation, validateInvitationQuery } from "../../graphql/queries";
import { type SignupMutation, type SignupMutationVariables, UserGroupType, type ValidateInvitationQuery, type ValidateInvitationQueryVariables } from "../../graphql/types";
import { globalUserState, setTokens } from "state";

export async function signup(name: string, email: string, password: string, invitation: string | null): Promise<boolean> {
    try {
        const signupResult = await fetchGraphql<SignupMutation, SignupMutationVariables>("Signup", signupMutation, {
            input: {
                name,
                email,
                password,
                userGroupId: invitation ? undefined : UserGroupType.User,
                invitation
            }
        }, false);

        if (!signupResult?.data?.user.createUser?.ok || !signupResult.data.user.createUser?.token?.accessToken || !signupResult.data.user.createUser.user) {
            // todo: error feedback
            return false;
        }

        setTokens(signupResult.data.user.createUser.token.accessToken, signupResult.data.user.createUser.token.refreshToken ?? undefined);
        globalUserState.value = {
            ...globalUserState.value,
            user: {
                id: signupResult.data.user.createUser.user.id,
                name: signupResult.data.user.createUser.user.name,
                email: signupResult.data.user.createUser.user.email,
                llmInstructions: "",
                features: []
            },
            status: "loggedin"
        };

        // todo: 

        return true;
    }
    catch {
    }
    return false;
}


export async function fetchValidateInvitation(token: string) {
    console.log("fetching invitation");
    return fetchGraphql<ValidateInvitationQuery, ValidateInvitationQueryVariables>("ValidateInvitation", validateInvitationQuery, { token }, false);
}

